module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ./~/react-csv/index.js
// module id = 1258
// module chunks = 0